export const RECEIPT_CONFIGURE_SLUGS = {
  business_info: "business_info",
  business_details: "business_details",
  payment_identifiers: "payment_identifiers",
  support_legal: "support_legal",
  preview: "preview"
}
